export const TYPE_WORKERS = {
    INITIAL_WORKER: 1,
    UPDATE_DATA_CONFIGS: 2,
    RECEIVED_NEW_MESSAGE: 3,
    UPDATE_CHANNEL_MESSAGES: 4,
    SENT_NEW_MESSAGE: 5,
    SET_DATA_CONFIGS: 6,
    RECEIVED_NEW_LIKE: 7,
    REMOVE_MESSAGE: 8
};
